const BASE_BODY = {
  operator: "globojogal",
  mode: "fun",
  channel: "desktop",
  jurisdiction: "99",
  token: "b",
  ip: "",
  user: "",
  disallowPromos: false,
};

async function tryPostLaunch(
  gameId: string,
  lang: string,
  currency: string
): Promise<string> {
  const response = await fetch(
    "https://sales.globalgames.io/slot-server/api/globojogal/get_launcher_url",
    {
      method: "POST",
      headers: { Token: "b", "Content-Type": "application/json" },
      body: JSON.stringify({
        ...BASE_BODY,
        game: gameId,
        lang,
        currency,
        lobby: window.location.origin + "/",
        cashier: window.location.origin + "/",
      }),
    }
  );

  if (!response.ok) throw new Error(`${response.status}`);

  const data = await response.json();
  if (data.error !== 0)
    throw new Error(data.description || `error ${data.error}`);
  const url = data.result?.url || data.result?.launchUrl || data.url;
  if (!url) throw new Error("No URL in response");
  return url;
}

const OW_DEV_IDS: string[] = [
  "BLINDFOLLOWINGTHEBLIND95",
  "LASTSTEP95",
  "SURVIVORWHEEL98",
];
const OW_QA_IDS: string[] = ["BALANCEBEAMCRASH4S7"];

export function getOWCasinoId(gameId: string) {
  if (OW_DEV_IDS.includes(gameId)) return 1;
  if (OW_QA_IDS.includes(gameId)) return 2;
}

export function getOWApiEnv(gameId: string) {
  if (OW_DEV_IDS.includes(gameId)) return 'dev';
  if (OW_QA_IDS.includes(gameId)) return 'qa';
}

const getOWLauncherUrl = (
  gameId: string,
  siteId: string,
  tokenId: string,
  userId: string,
  gameURL: string
) =>
  OW_QA_IDS.includes(gameId) ? 
  `${gameURL}?siteId=oddsworks&gameId=BALANCEBEAMCRASH4S7&userId=${userId}&locale=en&channel=mobile&gameMode=FUN&currency=USD&websocketAddress=wss://crashgames.qa.owbetguard.com/websocket&apiAddress=https://statics.dev.dsg-invent.com/frameworks/livegames/livegames-framework.es.js&token=${tokenId}}&ipaddress=127.0.0.1&lv=4.4.007&&`
  :
  `${gameURL}?siteId=oddsworks&serverAddress=https%3A%2F%2Fapp.${getOWApiEnv(gameId)}.owbetguard.com%2F&apiAddress=https%3A%2F%2Fassets.${getOWApiEnv(gameId)}.owbetguard.com%2Fmobile%2F&channel=mobile&language=ENG&locale=en&gameId=${gameId}&userId=${userId}&gameMode=FUN&currency=USD&useGrouping=1&groupingSeparator=%2C&decimalSeparator=.&music=1&sfx=1&gcp=1&msn=i19gg5f1j2ren8mo4rei8r4870&luid=GEN_TEST_ID&origin=https%3A%2F%2Femulator.owbetguard.com&lv=4.4.007&&`;

const getRandomToken = () => {
  return (
    Math.random().toString(36).substring(3, 15).toUpperCase() +
    "-" +
    Math.random().toString(36).substring(3, 11).toUpperCase() +
    "-" +
    Math.random().toString(36).substring(3, 6).toUpperCase()
  );
};
const getRandomURL = () => {
  return "TEST_USER_" + Math.random().toString().substring(3, 8).toUpperCase();
};

async function getOddsworkUrl(gameId: string, gameUrl: string) {
  const randomToken = getRandomToken();
  const randomUser = getRandomURL();
  const siteId = OW_DEV_IDS.includes(gameId)
    ? "oddsworks-dev"
    : OW_QA_IDS.includes(gameId)
    ? "oddsworks-dev"
    : null;
  if (!siteId) throw new Error("No env to launch");
  const launcherUrl = getOWLauncherUrl(
    gameId,
    siteId,
    randomToken,
    randomUser,
    gameUrl
  );
  
  return launcherUrl;
}

function getStaticUrl(gameId: string): string {
  return `https://sales.globalgames.io/rgs/games/v2/launch?gameId=${gameId}&lang=en&currency=EUR&gameMode=DEMO&operatorId=globojogal`;
}

export async function getLauncherUrl(
  gameId: string,
  launchProvider?: string,
  gameUrl?: string,
  lang?: string,
  currency?: string
): Promise<string> {
  // console.log('should open ', gameId, gameUrl);
  if (launchProvider === "oddswork" || OW_DEV_IDS.includes(gameId) || OW_QA_IDS.includes(gameId)) {
    if (!gameUrl) throw new Error("gameUrl is required for oddswork launcher");
    return getOddsworkUrl(gameId, gameUrl);
  }
  if (lang && currency) {
    return tryPostLaunch(gameId, lang, currency);
  }
  try {
    return await tryPostLaunch(gameId, "en-us", "USD");
  } catch {
    try {
      return await tryPostLaunch(gameId, "pt-BR", "BRL");
    } catch {
      return getStaticUrl(gameId);
    }
  }
}
